<template>
    <!-- Favorite POPUP ----------------------------------->
    <v-dialog v-model="Panel" width="300" persistent>     
        <v-card>
        <v-card-title :class="`modal-title-bar`" >
            <h4>Notificaties instellen</h4>
            <v-spacer></v-spacer>
            <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="close()"></i>                                
        </v-card-title>                                    
        </v-card>      
        <v-container column xs12 style="background-color:white;" align-center justify-center>
        <v-flex xs12>   
            <v-switch v-model="active" label="Als favoriet actief"></v-switch>                              
        </v-flex>        
        <v-flex xs12>   
            <v-switch v-model="notifications" label="Notificaties versturen"></v-switch>                              
        </v-flex>
        <v-flex xs12>
            <v-switch v-model="mail_notifications" label="Notifcaties mailen"></v-switch>        
        </v-flex>                        
        <v-flex xs12 d-flex>
            <v-btn @click="saveFavorite()">Opslaan</v-btn>
        </v-flex>            
        </v-container>           
    </v-dialog>  
</template> 
 
<script>
    import { mapGetters } from 'vuex'
    import * as types from "../../store/types"
    export default {
        name:"user-favorites",
        computed: {
            ...mapGetters({
                currentUser: types.CURRENT_USER,
                favoriteAssets:types.USER_FAVORITE_ASSETS,
            })
        },
        data() {
            return {   
                Panel:true,
                id:null,             
                active:false,
                notifications:false,
                mail_notifications:false,
            }
        },
        props: {
            favorite: {
                type: Object
            },
            assetId:{
                type:String
            },
            userId:{
                type:String
            }
        },
        methods: {
            close(){
                this.$emit("panelClosed")
            },
            saveFavorite(){
                let userId = this.userId ? this.userId : this.currentUser.id

                let data = {
                    id: this.id,
                    userId: userId,
                    assetId: this.assetId,
                    active: this.active ? true : false,
                    sendMail: this.mail_notifications ? true : false,
                    sendNotification: this.notifications ? true : false
                }

                this.$store.dispatch(types.SAVE_USER_FAVORITE_ASSET,{data:data}  ).then(() => {
                    this.$store.dispatch(types.USER_FAVORITE_ASSETS,{data:{"userId":userId },params:{per_page:200, include:"asset"}}).then(() => {
                        this.$notify("Favoriet instellingen opgeslagen", {duration:10000, type: 'success', icon:'check'} );                      
                        this.$emit("favoriteSaved")
                    })
                })
            },
        },
        mounted(){
            if(this.favorite){        
                this.id                 = this.favorite.id
                this.active             = this.favorite.active
                this.mail_notifications = this.favorite.sendMail
                this.notifications      = this.favorite.sendNotification  
            }   
        },
    }
</script>

<style lang="scss" scoped>

</style>